(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Theme fix: Shrine's MenuDrawer sets aria-expanded="true" on open but only
  // resets it on the click paths, so Escape (and focus leaving the panel)
  // closed the menu while the hamburger still announced itself expanded.
  // The details element is the source of truth; mirror its open state.
  // Listening on the document (capture, since toggle does not bubble) keeps it
  // working after the theme editor re-renders the header.
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details || !details.matches || !details.matches('header-drawer > details')) return;
    var summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }, true);

  // Noirarchy: Escape closes the phone menu even when focus is outside it (a tap
  // on the page can leave focus on the body). Shrine handles Escape inside it.
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var drawer = document.querySelector('.noir-header header-drawer');
    var details = drawer && drawer.querySelector(':scope > details[open]');
    if (!details || details.contains(event.target) || typeof drawer.closeMenuDrawer !== 'function') return;
    drawer.closeMenuDrawer(event, details.querySelector(':scope > summary'));
  });

  // Noirarchy: the Bags panel (header-menu) also closes on a click outside it,
  // and on Escape when focus never entered it. Safari does not focus a clicked
  // summary, so Shrine's focusout and its keyup Escape on the details can miss.
  // Escape with focus inside is Shrine's own wiring; by the time this document
  // handler runs that details is already closed.
  (function () {
    function openMenus() {
      return document.querySelectorAll('.noir-header header-menu > details[open]');
    }

    function closeMenu(details, returnFocus) {
      var menu = details.parentElement;
      var summary = details.querySelector(':scope > summary');
      if (menu && typeof menu.close === 'function') {
        menu.close();
      } else {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
      if (returnFocus && summary) summary.focus();
    }

    document.addEventListener('click', function (event) {
      openMenus().forEach(function (details) {
        if (!details.contains(event.target)) closeMenu(details, false);
      });
    });

    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      openMenus().forEach(function (details) {
        var active = document.activeElement;
        closeMenu(details, !active || active === document.body || details.contains(active));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
